import { productBadgeClass, productLabel, type ProductType } from './product.js';

export function ProductBadge({ type }: { type: ProductType }) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium ring-1 ${productBadgeClass(type)}`}
    >
      {productLabel(type)}
    </span>
  );
}
